/* ==========================================================================
   Eco-Eze Compot theme — AJAX cart
   Uses Shopify's /cart/add.js, /cart/change.js, /cart/update.js endpoints
   with the `sections` param so the drawer re-renders without a page reload.
   ========================================================================== */
(function () {
  'use strict';

  var CART_ADD_URL = '/cart/add.js';
  var CART_CHANGE_URL = '/cart/change.js';
  var CART_UPDATE_URL = '/cart/update.js';
  var CART_JSON_URL = '/cart.js';
  var SECTION_ID = 'cart-drawer';

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.message) || 'Cart request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function swapDrawerHTML(sectionHTML) {
    if (!sectionHTML) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(sectionHTML, 'text/html');
    var freshDrawer = doc.getElementById('CartDrawer');
    var currentDrawer = document.getElementById('CartDrawer');
    if (!freshDrawer || !currentDrawer) return;

    currentDrawer.innerHTML = freshDrawer.innerHTML;

    var freshCount = freshDrawer.querySelector('[data-cart-count]');
    var countValue = freshCount ? freshCount.textContent.replace(/[()]/g, '').trim() : null;
    if (countValue !== null) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        if (el.closest('#CartDrawer')) return; // already replaced above
        el.textContent = countValue;
        el.setAttribute('data-cart-count', countValue);
      });
    }
  }

  function showToast(message, opts) {
    opts = opts || {};
    var existing = document.querySelector('.cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.innerHTML =
      '<span class="icon">' +
      (opts.error
        ? '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16" x2="12" y2="16"/></svg>'
        : '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="20 6 9 17 4 12"/></svg>') +
      '</span><span>' + message + '</span>';
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () { toast.remove(); }, 250);
    }, 2600);
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('button--loading', isLoading);
    button.disabled = isLoading;
  }

  /* ---------------- Add to cart (product cards, cart upsell, quick add) ---------------- */
  function handleAddToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    var quantity = parseInt(button.getAttribute('data-quantity') || '1', 10);
    if (!variantId) return;

    setButtonLoading(button, true);

    postJSON(CART_ADD_URL, {
      items: [{ id: variantId, quantity: quantity }],
      sections: SECTION_ID
    })
      .then(function (data) {
        var sectionHTML = data.sections && data.sections[SECTION_ID];
        swapDrawerHTML(sectionHTML);
        window.CartDrawerActions && window.CartDrawerActions.open();
        var title = (data.items && data.items[0] && data.items[0].product_title) || 'Item';
        showToast(title + ' added to your cart');
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        var message = (err && err.data && err.data.description) || 'Couldn\'t add that item — please try again.';
        showToast(message, { error: true });
      })
      .finally(function () {
        setButtonLoading(button, false);
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-add-to-cart]');
    if (!button) return;
    e.preventDefault();
    if (button.disabled) return;
    handleAddToCart(button);
  });

  /* ---------------- Main product form (product page) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var submitButton = form.querySelector('[type="submit"]');
    setButtonLoading(submitButton, true);

    var formData = new FormData(form);
    var body = {
      items: [
        {
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity') || '1', 10)
        }
      ],
      sections: SECTION_ID
    };

    // Carry over any line item properties (e.g. gift message fields)
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) body.items[0].properties = properties;

    postJSON(CART_ADD_URL, body)
      .then(function (data) {
        var sectionHTML = data.sections && data.sections[SECTION_ID];
        swapDrawerHTML(sectionHTML);
        window.CartDrawerActions && window.CartDrawerActions.open();
        showToast((data.product_title || 'Item') + ' added to your cart');
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        var message = (err && err.data && err.data.description) || 'This item is unavailable right now.';
        showToast(message, { error: true });
      })
      .finally(function () {
        setButtonLoading(submitButton, false);
      });
  });

  /* ---------------- Quantity stepper + remove (inside drawer) ---------------- */
  function changeLine(line, quantity, rowEl) {
    if (rowEl) rowEl.classList.add('is-updating');
    postJSON(CART_CHANGE_URL, { line: line, quantity: quantity, sections: SECTION_ID })
      .then(function (data) {
        var sectionHTML = data.sections && data.sections[SECTION_ID];
        swapDrawerHTML(sectionHTML);
        document.dispatchEvent(new CustomEvent('cart:updated'));
        // The dedicated /cart page renders a full item table + totals that
        // aren't covered by the drawer section swap above, so refresh it.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function () {
        showToast('Couldn\'t update your cart — please try again.', { error: true });
        if (rowEl) rowEl.classList.remove('is-updating');
      });
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest('[data-cart-item]');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var input = row.querySelector('[data-quantity-input]');

    if (e.target.closest('[data-quantity-increase]')) {
      var next = parseInt(input.value, 10) + 1;
      input.value = next;
      changeLine(line, next, row);
    } else if (e.target.closest('[data-quantity-decrease]')) {
      var prev = Math.max(0, parseInt(input.value, 10) - 1);
      input.value = prev;
      changeLine(line, prev, row);
    } else if (e.target.closest('[data-cart-remove]')) {
      changeLine(line, 0, row);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    var row = input.closest('[data-cart-item]');
    var line = parseInt(row.getAttribute('data-line'), 10);
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(line, quantity, row);
  });

  /* ---------------- Order notes ---------------- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var textarea = e.target.closest('[data-cart-note]');
    if (!textarea) return;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      postJSON(CART_UPDATE_URL, { note: textarea.value }).catch(function () {});
    }, 500);
  });

  /* ---------------- Discount code ----------------
     Shopify does not expose a public endpoint to validate/apply a discount
     to the cart before checkout. We store the code and apply it via the
     `discount` query param when the shopper proceeds to checkout — the
     standard workaround for theme-level (non Shopify Functions) carts. */
  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-discount-apply]');
    if (!applyBtn) return;
    var input = document.querySelector('[data-discount-input]');
    var note = document.querySelector('[data-discount-note]');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    window.sessionStorage.setItem('pendingDiscountCode', code);
    if (note) {
      note.hidden = false;
      note.textContent = 'Code "' + code + '" will be applied at checkout.';
      note.className = 'cart-discount__note cart-discount__note--success';
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#cart-drawer-checkout-form, #cart-page-checkout-form');
    if (!form) return;
    var code = window.sessionStorage.getItem('pendingDiscountCode');
    if (code) {
      e.preventDefault();
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }
  });

  /* ---------------- Custom element registration (progressive enhancement) ---------------- */
  if (window.customElements && !customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {});
  }
})();
